import { createGlobalStyle } from 'styled-components';

const GlobalStyle = createGlobalStyle`

body {
    background-color: #efe;
}

* {
    margin: 0;
    padding: 0;
}

`;

export default GlobalStyle;
